import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DeviceService } from '../../../_services/device.service';
import { PlayerService } from '../../../_services/player.service';
import { LocationService } from '../../../_services/location.service';

export const deviceResolver = (route: ActivatedRouteSnapshot) => {
  const dService = inject(DeviceService);

  const pService = inject(PlayerService);

  const lService = inject(LocationService);

  const router = inject(Router);

  return dService.getEntity(route.params.id).pipe(
    switchMap((device) => forkJoin({
      player: pService.getEntity(device.configuration?.info?.playerId).pipe(catchError(() => of(null))),
      location: lService.getEntity(device.configuration?.info?.locationId).pipe(catchError(() => of(null))),
    }).pipe(
      map(({ player, location }) => ({ device, player, location })),
    )),
    catchError((err) => {
      if (err.status === 403) {
        router.navigate(['/error/not-authorized']);
      } else {
        router.navigate(['/error/not-found']);
      }
      return EMPTY;
    }),
  );
};
